import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class Spinner extends Component {
  render() {
    return (
      <Modal
        backdropClassName="spinner-backdrop"
        bsSize="small"
        dialogClassName="spinner-modal"
        show={this.props.showSpinner}
      >
        <Modal.Body className="spinnerBody">
          <center>
            <span className={`lds-roller ${this.props.showSpinner ? "show" : "hide"}`}>
              <div />
              <div />
              <div />
              <div />
            </span>
          </center>
        </Modal.Body>
      </Modal>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/containers/User/Common/Spinner/Spinner.js